import React from 'react';

export const UserProfileImage: React.FC = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9445 30.6666C24.0167 30.6666 30.5604 24.1001 30.5604 15.9999C30.5604 7.89974 24.0167 1.33325 15.9445 1.33325C7.87238 1.33325 1.32861 7.89974 1.32861 15.9999C1.32861 24.1001 7.87238 30.6666 15.9445 30.6666Z"
        stroke="#697684"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2222 27.3335C22.6986 29.4161 19.4671 30.6666 15.9446 30.6666C12.4221 30.6666 9.19059 29.4161 6.66693 27.3335C6.65143 27.1132 6.64355 26.8908 6.64355 26.6666C6.64355 21.5119 10.8078 17.3333 15.9446 17.3333C21.0814 17.3333 25.2456 21.5119 25.2456 26.6666C25.2456 26.8908 25.2377 27.1132 25.2222 27.3335Z"
        stroke="#697684"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9445 17.3332C18.8798 17.3332 21.2594 14.9454 21.2594 11.9998C21.2594 9.05432 18.8798 6.6665 15.9445 6.6665C13.0092 6.6665 10.6296 9.05432 10.6296 11.9998C10.6296 14.9454 13.0092 17.3332 15.9445 17.3332Z"
        stroke="#697684"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
